import React from 'react';

const SectionSecond = () => {
  return (
    <div>
      <div className="spacer waves-bottom-1"></div>
    </div>
  );
};

export default SectionSecond;
